import ShiftInvoiceContainer from "./ShiftInvoiceContainer";

export default ShiftInvoiceContainer;
